import { useExperiment } from "../../hooks/experiments";
import { QuoteCards as Control } from "./QuoteCards";
import { QuoteCards as GridViewTreatment } from "./ExperimentGridView/QuoteCards";
import { type QuoteCardsProps } from "./QuoteCards";

export * from "./QuoteCard";
export { type QuoteCardsProps } from "./QuoteCards";

export const QuoteCards = (props: QuoteCardsProps) => {
  const isGridView = ["treatment_grid", "treatment_list"].includes(
    useExperiment("uk2505Gridvslistview") || "",
  );

  if (isGridView) {
    return <GridViewTreatment {...props} />;
  }

  return <Control {...props} />;
};
